import { get } from 'lodash-es';

import commaSeparate from './commaSeparate';

const pickCommaSeparate = (obj: Record<string, string>, arr: string[]): string =>
  commaSeparate(arr.map((item) => get(obj, item)));

export default pickCommaSeparate;
